module.exports = __webpack_public_path__ + "assets/images/figurine_ric.fedda98.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_ric.png
// module id = 364
// module chunks = 1